// extracted by mini-css-extract-plugin
export default {"techIcon__style":"TechExpertiseIcons_techIcon__style__a1mMt"};